export default function sendTo(url) {
    try {
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.send();
    }
    catch (error) {
        var img = new Image();
        img.src = url;
    }
}
//# sourceMappingURL=send-to.js.map


//////////////////
// WEBPACK FOOTER
// ../tracker/build/src/send-to.js
// module id = 1118
// module chunks = 0